// Shared API helpers: backend base URL + Bearer-token-aware fetch.
//
// The backend issues an opaque session token on login (see
// portalbackend/Backend/auth_guard.php) that must be sent back as
// `Authorization: Bearer <token>` on any endpoint that calls
// require_portal_session(). This file is the one place that reads/writes
// that token so every page uses the same storage key and header shape.

export const API_BASE = 'https://dev.sliitleo.org/Backend';

const TOKEN_KEY = 'portal_token';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || '';
}

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

/**
 * fetch() wrapper that adds the Bearer token (when present) and a default
 * JSON content-type for non-GET requests. Usage is identical to fetch().
 */
export function authFetch(url, options = {}) {
  const token = getToken();
  const headers = { ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  if (options.body && !(options.body instanceof FormData) && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }
  return fetch(url, { ...options, headers });
}

/** Read the currently logged-in user's role/id from localStorage (or null). */
export function getCurrentUser() {
  try {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    return user && typeof user === 'object' ? user : null;
  } catch {
    return null;
  }
}
